import React, { useEffect, useState } from 'react';
import { Modal, Button, Table, Pagination } from 'react-bootstrap';
import _ from 'lodash';
import Whatsapp from '../assets/images/whatsapp.svg';

import ExportAbstentions from './ExportAbstentions';

function Abstentions(props) {
  const limit = 100;
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [abstentionData, setAbstentionData] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [countAbstentions, setCountAbstentions] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const {
    getAbstentions,
    monthFilter,
    areasFilter,
    unitFilter,
    refreshCount,
    setAbstentionsCount
  } = props;

  useEffect(() => {
    async function fetchData() {
      setLoaded(false);
      const _abstentionsData = await getAbstentions({
        limit,
        page,
        monthFilter,
        areasFilter,
        unitFilter
      });
      const { data, count } = _abstentionsData;
      setAbstentionData(data);
      setCountAbstentions(count);
      setAbstentionsCount(count);
      setPages(Math.ceil(count / limit));
      setLoaded(true);
    }
    fetchData();
  }, [
    page,
    monthFilter,
    areasFilter,
    unitFilter,
    refreshCount,
    getAbstentions,
    setAbstentionsCount
  ]);

  return (
    <>
      {loaded && countAbstentions > 0 ? (
        <Button variant="primary" onClick={handleShow}>
          {countAbstentions} pulso{countAbstentions > 1 ? 's' : ''} não medido
          {countAbstentions > 1 ? 's' : ''}
        </Button>
      ) : loaded && countAbstentions == 0 ? (
        <Button variant="primary">Todos os pulsos medidos!</Button>
      ) : (
        <Button variant="secondary" disabled>
          Calculando abstenções...
        </Button>
      )}
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Pulsos não medidos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ExportAbstentions data={abstentionData} monthFilter={monthFilter} />

          <Table responsive bordered style={{ width: `${100}%` }}>
            <thead>
              <tr>
                <th className="name-header">Nome</th>
                <th className="name-header">Área</th>
              </tr>
            </thead>
            {!loaded ? (
              <div className="table-spinner d-flex justify-content-center">
                <div className="spinner-border" />
              </div>
            ) : (
              <tbody>
                {_.map(abstentionData, (user, id) => (
                  <tr key={id}>
                    <td>
                      {user.phone ? (
                        <a
                          target="_blank"
                          href={`https://api.whatsapp.com/send?phone=55${
                            user.phone
                          }&text=Oi%20${String(user.name)
                            .split(' ')
                            .slice(0, 1)
                            .join(
                              ' '
                            )}%2C%20vi%20que%20voc%C3%AA%20n%C3%A3o%20respondeu%20o%20Pulso%20deste%20m%C3%AAs...%20voc%C3%AA%20poderia%20responder%20por%20favor%3F%20Acesse%20https://app.fiter.com.br%2C%20fa%C3%A7a%20login%20com%20seu%20CPF`}
                        >
                          <img
                            src={Whatsapp}
                            alt="Enviar lembrete via Whatstapp"
                            style={{ width: `${25}px` }}
                          />
                        </a>
                      ) : (
                        ''
                      )}
                      <span> {user.name}</span>
                    </td>
                    <td>{user.areaLabel}</td>
                  </tr>
                ))}
              </tbody>
            )}
          </Table>
          <Pagination>
            {pages > 1 ? (
              <Pagination.Prev
                disabled={page === 1}
                onClick={() => setPage(page - 1)}
              />
            ) : (
              <></>
            )}
            <Pagination.Item active={page === 1} onClick={() => setPage(1)}>
              1
            </Pagination.Item>

            {pages > 2 && page !== 1 && page !== pages ? (
              <>
                {page !== 1 ? <Pagination.Ellipsis disabled /> : <></>}
                <Pagination.Item active>{page}</Pagination.Item>
                {page !== pages - 2 ? <Pagination.Ellipsis disabled /> : <></>}
              </>
            ) : (
              <Pagination.Ellipsis disabled />
            )}

            {pages > 1 ? (
              <>
                <Pagination.Item
                  active={page === pages}
                  onClick={() => setPage(pages)}
                >
                  {pages}
                </Pagination.Item>
                <Pagination.Next
                  disabled={page === pages}
                  onClick={() => setPage(page + 1)}
                />
              </>
            ) : (
              <></>
            )}
          </Pagination>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Abstentions;
